import React from "react";
import { useParams, useLoaderData } from "react-router-dom";
import { FullPagePaperLayout } from "../Layouts/FullPagePaperLayout";
import { PageBreadcrumbs, PageSubtitle, PageTitle } from "../Layouts/components/PageTitleContainer";
import { Stack, Button, Select, MenuItem, Box, TextField } from "@mui/material";
import { LocationTypeMovementBlock } from "types/locationManagement/locationTypeMovementBlock";
import { LocationManagementLocationType } from "types/locationManagement/locationType";
import { FieldControl } from "components/Form/FieldControl";
import { Form } from "components/Form/Form";

const LocationTypeMovementBlockForm: React.FC = () => {
  const { locationTypeMovementBlockId } = useParams<{ locationTypeMovementBlockId?: string }>();
  const isEdit = Boolean(locationTypeMovementBlockId);
  const { block, locationTypes } = useLoaderData() as {
    block: LocationTypeMovementBlock;
    locationTypes: LocationManagementLocationType[];
  };

  return (
    <FullPagePaperLayout>
      <PageBreadcrumbs
        links={[
          { label: "Admin", path: "/" },
          { label: "Location Type Movement Blocks", path: "/location-type-movement-blocks" },
        ]}
      />
      <PageTitle>{isEdit ? "Edit" : "Create"} Rule</PageTitle>
      <PageSubtitle>
        Define a rule to block moving inventory from one Location Type to another. A user will get an error that this is
        an invalid location movement and be blocked from proceeding.{" "}
      </PageSubtitle>
      <Box sx={{ m: 3 }}>
        <Form method={isEdit ? "PUT" : "POST"} resource="locationTypeMovementBlock">
          <Stack direction="column" spacing={2}>
            <FieldControl
              name="fromLocationTypeId"
              label="From Location Type"
              inputProps={{ defaultValue: block.fromLocationType.id || "" }}
              required
            >
              {({ name, label, defaultValue, labelId }) => (
                <Select name={name} labelId={labelId} defaultValue={defaultValue} required label={label}>
                  {locationTypes.map((locationType) => (
                    <MenuItem key={locationType.id} value={locationType.id}>
                      {locationType.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FieldControl>
            <FieldControl
              name="toLocationTypeId"
              label="To Location Type"
              inputProps={{ defaultValue: block.toLocationType.id || "" }}
              required
            >
              {({ name, label, defaultValue, labelId }) => (
                <Select name={name} labelId={labelId} defaultValue={defaultValue} required label={label}>
                  {locationTypes.map((locationType) => (
                    <MenuItem key={locationType.id} value={locationType.id}>
                      {locationType.name}
                    </MenuItem>
                  ))}
                </Select>
              )}
            </FieldControl>
            <FieldControl
              name="description"
              label="Description"
              inputProps={{ defaultValue: block.description || "" }}
              component={TextField}
            />
            <div>
              <Button type="submit" variant="contained">
                {isEdit ? "Update" : "Create"}
              </Button>
            </div>
          </Stack>
        </Form>
      </Box>
    </FullPagePaperLayout>
  );
};

export default LocationTypeMovementBlockForm;
